import React, { useState, useEffect, useRef } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import Button from "./Button";
import { type } from "@testing-library/user-event/dist/type";

function ChatusForm({ property_name }) {
  const { pathname } = useLocation();
  const page = pathname.split("/").filter(Boolean);
  const key = page.length === 2 ? page[1] : page[0];
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  const now = new Date();
  const CurrentDate = new Date().toISOString().split("T")[0];
  const CurrentTime = now.toTimeString().split(" ")[0];

  const initialvalues = {
    name: "",
    phonenumber: "",
    page_data: "chatwithus",
    date_of_enquiry: CurrentDate,
    time_of_enquiry: CurrentTime,
  };
  const [formValues, setFormValues] = useState(initialvalues);
  const form = useRef();
  const [formErrors, setFormErrors] = useState(false);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value,
      property_name: property_name,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const error = validate(formValues);
    setFormErrors(error);
    if (Object.keys(error).length === 0) {
      console.log(formValues);
      handleGSheet();
      const message = `Hi, I am ${formValues.name} looking for a `;
      setTimeout(() => {  
        window.location.href= `https://wa.me/918925837928/?text=${message}`
      },500)
      setFormValues(initialvalues);

      
    }
  };

  //Error hiding function (UX Improvement)
  const handleFocus = (e) => {
    const { name } = e.target;
    if (formErrors[name]) {
      setFormErrors((prev) => {
        const updatedErrors = { ...prev };
        delete updatedErrors[name];
        return updatedErrors;
      });
    }
  };
  const validate = (values) => {
    const errors = {};
    // const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
    if (!values.name) {
      errors.name = "Name is Required";
    }
    if (!values.phonenumber) {
      errors.phonenumber = "Phone Number is Required";
    } else if (isNaN(values.phonenumber)) {
      errors.phonenumber = "Invalid Phone Number";
    } else if (values.phonenumber.length !== 10) {
      errors.phonenumber = "Invalid Phone Number";
    }
    return errors;
  };
  const handleGSheet = () => {
    fetch(
      "https://script.google.com/macros/s/AKfycbxZBjt2g3w_92ReBF1_t-iEo5NxFcR4rr4EJMeGuMdoyPKfjMR9Tk8S1XXpO9RIj36Q/exec",
      {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(formValues).toString(),
      }
    )
      .then((res) => res.text(console.log("response", res)))
      .then((data) => {
        console.log("data", data);
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  return (
    <>
      {/* Modal */}
      <div
        className="w-full h-full mx-auto sm:mt-[40px] sm:px-0"
        data-aos="fade-up"
      >
        <h2 className="text-center font-alibaba  text-[18px] leading-[27px] sm:text-[20px] font-normal sm:leading-[32px] capitalize ">
         Connect with our Sales Expert
        </h2>
        <hr className="border-yellow border-[2px] w-[50px] lg:w-[87px] mx-auto sm:mt-5 sm:mb-3 my-3" />

        <div>
          <form
            className={
              pathname === "/contact"
                ? "flex flex-col gap-y-3 sm:gap-y-7"
                : "flex flex-col gap-y-3 sm:gap-y-5"
            }
            ref={form}
            onSubmit={handleSubmit}
          >
            <div>
              <p className="input-heading">
                Name <span className="text-[#FF0000]">*</span>
              </p>
              <input
                className="input-box"
                type="text"
                name="name"
                onChange={handleChange}
                onFocus={handleFocus}
              />
              <span className="error-msg">{formErrors.name} </span>
            </div>

            <div>
              <p className="input-heading">
                Phone <span className="text-[#FF0000]">*</span>
              </p>
              <input
                className="input-box"
                type="Phone"
                name="phonenumber"
                onChange={handleChange}
                onFocus={handleFocus}
                maxLength={10}
              />
              <span className="error-msg">{formErrors.phonenumber}</span>
            </div>

            <Button name={"Submit"} design={"filled"} action={"form-submit"} />
          </form>
        </div>
      </div>
    </>
  );
}

export default ChatusForm;
